const USER_CATEGORY_LABELS = {
  behavior: 'Behavior',
  medication: 'Meds',
  food: 'Food',
  sleep: 'Sleep',
  mood: 'Mood',
  activity: 'Activity',
  health: 'Health',
  milestone: 'Milestone',
  bathroom: 'Toilet',
  dailyLog: 'Daily Log',
};

const USER_CATEGORY_PRIORITY = [
  'behavior',
  'medication',
  'food',
  'sleep',
  'mood',
  'activity',
  'health',
  'milestone',
  'bathroom',
  'dailyLog',
];

const RECORD_TYPE_CATEGORY_MAP = {
  medication_admin: 'medication',
  sleep_period: 'sleep',
  food_intake: 'food',
  health_note: 'health',
  appointment: 'health',
  milestone: 'milestone',
  routine: 'dailyLog',
  event: 'behavior',
  observation: 'dailyLog',
  general_note: 'dailyLog',
};

const FACT_CATEGORY_MAP = {
  sleep: 'sleep',
  food: 'food',
  medication: 'medication',
  behavior: 'behavior',
  mood: 'mood',
  activity: 'activity',
  health: 'health',
  environment: 'dailyLog',
  people: 'dailyLog',
};

export const buildRawCaptureUserFacingCategories = ({ recordType, facts = {} } = {}) => {
  const categoryKeys = Object.entries(FACT_CATEGORY_MAP).reduce((keys, [factKey, categoryKey]) => {
    if (facts[factKey]?.length) {
      keys.add(categoryKey);
    }
    return keys;
  }, new Set());

  categoryKeys.add(RECORD_TYPE_CATEGORY_MAP[recordType] || 'dailyLog');

  return USER_CATEGORY_PRIORITY
    .filter((categoryKey) => categoryKeys.has(categoryKey))
    .map((categoryKey) => ({
      category: categoryKey,
      label: USER_CATEGORY_LABELS[categoryKey] || categoryKey,
    }));
};

export const getPrimaryRawCaptureUserFacingCategory = (categories = []) => (
  categories[0] || { category: 'dailyLog', label: USER_CATEGORY_LABELS.dailyLog }
);
